import appStyles from '@root/appStyles';
import colors from '@theme/colors';
import React from 'react';
import { KeyboardAvoidingView, Platform, StatusBar } from 'react-native';
import ChatScreenUI from './ChatScreenUI';

function ChatScreen(): JSX.Element {
  return (
    <>
      <StatusBar backgroundColor={colors.secondary.orchid} translucent={false} hidden={false} />
      <KeyboardAvoidingView
        behavior={Platform.select({ ios: 'position', android: 'padding' })}
        enabled
        contentContainerStyle={appStyles.flex1}
        keyboardVerticalOffset={Platform.select({ android: 100 })}
        style={appStyles.flex1}>
        <ChatScreenUI />
      </KeyboardAvoidingView>
    </>
  );
}

export default ChatScreen;
